import slideImage1 from './assets/images/slider-image13.jpeg'
import slideImage2 from './assets/images/slider-image11.jpeg'
import slideImage3 from './assets/images/slider-image16.jpeg'

// categories images
// link for hosting on vps server
// https://www.youtube.com/watch?v=Nxw2j1-srVc

import slideImageCat1 from './assets/images/women-cat1.jpeg'
import slideImageCat2 from './assets/images/slider-image3.jpg'
import slideImageCat7 from './assets/images/slider-image12.jpg'
import slideImageCat9 from './assets/images/slider-image7.jpg'
import slideImageCat10 from './assets/images/slider-image5.jpg'
import maleCat from './assets/images/male.jpeg'
import accessories from './assets/images/accessory-cat.jpeg'
import Jumpsuits from './assets/images/ILU_1557.jpg'
import asoEbi from './assets/images/aso-ebi.jpeg'
import adireBubu from './assets/images/adire-bubu.jpeg'
import palazo from './assets/images/palazo.jpeg'
import fabricStack from './assets/images/fabric-stack.jpeg'
import children from './assets/images/children.jpeg'
// testimonial images

import custImage1 from './assets/images/cust1.png'
import custImage2 from './assets/images/cust2.jfif'
import custImage3 from './assets/images/cust3.jfif'
import custImage4 from './assets/images/cust4.jfif'

// fabric-stack

export const sliderItems = [
    {
        id: 1,
        img: slideImage1,
        title: "SUMMER SALE",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 10% OFF FOR NEW ARRIVALS.",
        bg: "#EFE6E5"
    },
    {
        id: 2,
        img: slideImage2,
        title: "READY TO WEAR OUTFITS",
        desc: "TAILORED JUST FOR YOU!",
        bg: "#EFE6E5"
    },
    {
        id: 3,
        img: slideImage3,
        title: "POPULAR SALE",
        desc: "DON'T COMPROMISE ON STYLE! GET FLAT 10% OFF FOR NEW ARRIVALS.",
        bg: "#EFE6E5"
    }
]

// categories

export const categories = [
    {
        id: 1,
        img: slideImageCat1,
        cat: "women",
        catValue: "women"
    },
    {
        id: 2,
        img: maleCat,
        cat:"Men",
        catValue: "men"
    },
    {
        id: 3,
        img: accessories,
        cat: "accessories",
        catValue: "accessories"
    },
    {
        id: 4,
        img: Jumpsuits,
        cat: "Track suits",
        catValue: "track-suits"
    },
    {
        id: 5,
        img: fabricStack,
        cat: "Fabrics",
        catValue: "fabrics"
    },
    {
        id: 6,
        img: adireBubu,
        cat: "Adire/Bubu dress",
        catValue: "adireBubu-dress"
    },
    {
        id: 7,
        img: slideImage1,
        cat: "Ankara set",
        catValue: "ankara-set"
    },
    {
        id: 8,
        img: palazo,
        cat: "2pieces set",
        catValue: "2pieces-set"
    },
    {
        id: 11,
        img: children,
        cat: "Children",
        catValue: "children"
    }
]

// Popular Products

export const popularProducts = [
    {
        id: 1,
        img: slideImage1,
        title: "shirt",
        review: 3
    },
    {
        id: 2,
        img: slideImage2,
        title: "shirt",
        review: 2
    },
    {
        id: 3,
        img: slideImage3,
        title: "shirt",
        review: 6
    },
    {
        id: 4,
        img: slideImageCat2,
        title: "shirt",
        review: 9
    },
    {
        id: 5,
        img: slideImageCat10,
        title: "shirt",
        review: 345
    },
    {
        id: 6,
        img: slideImageCat9,
        title: "shirt",
        review: 345
    },
    {
        id: 7,
        img: slideImageCat10,
        title: "shirt",
        review: 345
    },
    {
        id: 8,
        img: slideImageCat7,
        title: "shirt",
        review: 345
    }
]

// testimonials

export const customerTestimonials = [
    {
        id: 1,
        img: custImage1,
        name: "@Banks_Adeyemi",
        desc: "At first I was contemplating whether to get some designs from JPosh, I eventually did and trust me they were exactly what I wanted. The customer service is just a top notch.",
    },
    {
        id: 2,
        img: custImage2,
        name: "@elora_clothing2020",
        desc: "Jposh you outdid yourself again. I have no single doubt about you when it comes to sewing. This particular dress I give it you. You made this dress just by seeing her pictures, no measurement and it was exact her size. I give it to you. Thank you so much. The dad said all the mother's at the party took your contact as they couldn't get over the dress on her. They all thought it was ready-made ",
    },
    {
        id: 3,
        img: custImage3,
        name: "@chocolatelynda",
        desc: "Thank you Jposh for always giving the best. It is always a delight and a wonderful experience shopping with you....... I look forward to seeing and shopping your latest designs 😍 😊……I recommend Jposh with my full chest",
    },
    {
        id: 4,
        img: custImage1,
        name: "@Nneka Olamide",
        desc: ` J-Posh!!!
        Sincerely, you're the best!!!!!!! All my outfits came out nice, despite the fact that I couldn't make it for measurements and fittings More Grace hun!!.
        you are creative Abeg`,
    },
    {
        id: 5,
        img: custImage3,
        name: "@elora_clothing2020",
        desc: "Jposh you outdid yourself again. I have no single doubt about you when it comes to sewing. This particular dress I give it you. You made this dress just by seeing her pictures, no measurement and it was exact her size. I give it to you. Thank you so much. The dad said all the mother's at the party took your contact as they couldn't get over the dress on her. They all thought it was ready-made "
    },
    {
        id: 6,
        img: custImage2,
        name: "@Banks_Adeyemi",
        desc: "At first I was contemplating whether to get some designs from JPosh, I eventually did and trust me they were exactly what I wanted. The customer service is just a top notch.",
    },
    {
        id: 7,
        img: custImage4,
        name: "@elora_clothing2020",
        desc: "Jposh you outdid yourself again. I have no single doubt about you when it comes to sewing. This particular dress I give it you. You made this dress just by seeing her pictures, no measurement and it was exact her size. I give it to you. Thank you so much. The dad said all the mother's at the party took your contact as they couldn't get over the dress on her. They all thought it was ready-made "
    }
]

// sample articles
export const articles = [
    {
        id: '123a',
        title: "Future of work",
        desc: "Majority of peole will work in jobs that don’t exist today."
    },
    {
        id: '153au',
        title: "Future of work",
        desc: "Majority of peole will work in jobs that don’t exist today."
    },
    {
        id: '12a',
        title: "Future of work",
        desc: "Majority of peole will work in jobs that don’t exist today."
    },
    {
        id: '123aut89',
        title: "Future of work",
        desc: "Majority of peole will work in jobs that don’t exist today."
    },
    {
        id: '123atddse',
        title: "Future of work",
        desc: "Majority of peole will work in jobs that don’t exist today."
    },
    {
        id: '123a8jr',
        title: "Future of work",
        desc: "Majority of peole will work in jobs that don’t exist today."
    },
    {
        id: '9823auj',
        title: "Future of work",
        desc: "Majority of peole will work in jobs that don’t exist today."
    },
    {
        id: '125atg',
        title: "Future of work",
        desc: "Majority of peole will work in jobs that don’t exist today."
    }
    ,{
        id: '126akios',
        title: "Future of work",
        desc: "Majority of peole will work in jobs that don’t exist today."
    },
    {
        id: '127ajksks',
        title: "Future of work",
        desc: "Majority of peole will work in jobs that don’t exist today."
    }
]